// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import FullScreenModal from '../../../modal/FullScreenModal';
import AnchorButton from '../../../buttons/AnchorButton';

import './BrowserMobileDemoBoardFullScreenWarning.scss';

const BrowserMobileDemoBoardFullScreenWarning = ({ acknowledgeUnsupportedBrowser }) => (
    <FullScreenModal className="BrowserMobileDemoBoardFullScreenWarning">
        <h2>Better on desktop</h2>

        <p className="explanation">Because Milanote is so visual, these examples work best on a larger screen.</p>

        <div className="laptop">
            <img src={require('./milanote-laptop.png')} alt="" />
        </div>

        <AnchorButton onClickFn={acknowledgeUnsupportedBrowser}>Continue anyway...</AnchorButton>
    </FullScreenModal>
);

BrowserMobileDemoBoardFullScreenWarning.propTypes = {
    acknowledgeUnsupportedBrowser: PropTypes.func,
};

export default BrowserMobileDemoBoardFullScreenWarning;
